import { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTag } from '@fortawesome/free-solid-svg-icons'; // Import the icon you want to use
import styles from './PlotInput.module.scss'

const PlotInput = ({ selectedPlot, plots, setSelectedPlot}) => {
  const [showInput, setShowInput] = useState(false);
 
  return (
    <div className={styles.plotInputContainer}>
      {!showInput && (
        <FontAwesomeIcon
          icon={faTag}
          className={styles.icon}
          onClick={() => setShowInput(true)}
        />
      )}

    
      {showInput && (
        <input
          type="text"
          //value={selectedPlot ? selectedPlot.plotId : ''}
          onChange={(e) => {
           
            //const plotId = parseInt(e.target.value);
            const plot = plots.find(p => p.plotId === e.target.value.toUpperCase());
            setSelectedPlot(plot);
          }}
          placeholder="Enter plot ID to tag (optional)"
          className={styles.plotInput}
        />
      )}
    </div>
  );
};

export default PlotInput;
